module.exports = __webpack_public_path__ + "static/media/zip-homepage.6cb0a1af.svg";